import { OrderedSet, List } from 'immutable';

// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  types: [
    { value: 0, key: 'psychologist', label: 'Psychologist' },
    { value: 1, key: 'physician', label: 'Physician' },
    { value: 2, key: 'dietitian', label: 'Dietitian' },
    { value: 3, key: 'trainer', label: 'Trainer' },
    { value: 4, key: 'executive', label: 'Executive' },
    { value: 5, key: 'support_group', label: 'Support Group' },
    { value: 6, key: 'chatbot', label: 'Chatbot' },
    { value: 7, key: 'holistic', label: 'Holistic' },
    { value: 8, key: 'pharmacist', label: 'Pharmacist' },
    { value: 9, key: 'physiotherapist', label: 'Physiotherapist' },
    { value: 10, key: 'care_coordinator', label: 'Care Coordinator' },
  ],
  listings: List(),
  comments: OrderedSet(),
  pagination: null,
  currentPage: 1,
  totalPage: 1,
  getNotesPending: true,
  getNotesError: null,
  createNotePending: false,
  createNoteError: null,
  updateNotePending: false,
  updateNoteError: null,
  getCommentsPending: false,
  getCommentsError: null,
  createCommentPending: false,
  createCommentError: null,
  updateCommentPending: false,
  updateCommentError: null,
  getSearchPending: false,
  getSearchError: null,
  deleteNotePending: false,
  deleteNoteError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/notes/redux/initialState.js